import React from 'react';
import useTranslate from 'lib/languages/useTranslate';

interface PaymentSwitchProps {
    active: boolean;
    ukClick: () => void;
    intClick: () => void;
}

const PaymentSwitch = ({ active, ukClick, intClick }: PaymentSwitchProps) => {
    const translate = useTranslate('makePayment');

    return (
        <div className="payee-switch-container">
            <button
                type="button"
                onClick={ukClick}
                className={`switch ${!active ? 'active' : ''}`}
            >
                <h6>{translate('makePaymentTab1')}</h6>
            </button>
            <button
                type="button"
                onClick={intClick}
                className={`switch ${active ? 'active' : ''}`}
            >
                <h6>{translate('makePaymentTab2')}</h6>
            </button>
        </div>
    );
};

export default PaymentSwitch;
